import { Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import { useAppSelector } from "../../../app/store";
import BSRM_Logo_2 from "../../../assets/images/bsrm-logo-2.svg";
import BSRM_Logo from "../../../assets/images/bsrm-logo.svg";
import Sheba_Logo from "../../../assets/images/Sheba-Business-Logo.svg";
import upscaleLogo from "../../../assets/images/up_scale_logo/upscal__logo.svg";
import AllSidebarMenu from "../../../constants/AllSidebarMenu";
import { APP_NAME } from "../../../constants/constants";
import {
  activePathString,
  pathString,
  stringToArray,
} from "../../../utils/array";
import Image from "../../ui/Image";

type MenuItem = Required<MenuProps>["items"][number];

type SidebarItemProps = {
  collapsed: boolean;
  openMenuKeys: string[];
  handleOpenMenu: (keys: string[]) => void;
};

export default function SidebarItems({
  collapsed,
  openMenuKeys,
  handleOpenMenu,
}: SidebarItemProps) {
  const location = useLocation();
  const { role } = useAppSelector((state) => state.auth);

  function getItem(
    label: React.ReactNode,
    path: string,
    icon?: React.ReactNode,
    children?: MenuItem[],
    roles?: string[]
  ): MenuItem {
    return {
      key: pathString(path),
      icon,
      children,
      label: children?.length ? label : <Link to={path}>{label}</Link>,
      roles,
    } as MenuItem;
  }

  // filter allowed menu
  const MenuItems: MenuItem[] = AllSidebarMenu.filter((el) =>
    el?.role?.find((rl) => rl === role)
  ).map(({ name, path, icon: Icon, children }) =>
    getItem(
      name,
      path,
      Icon && <Icon />,
      children?.length
        ? children
            .filter((el) => el?.role?.find((rl) => rl === role))
            .map(({ name: cdName, path: cdPath, icon: CDIcon }) =>
              getItem(cdName, cdPath, CDIcon && <CDIcon />)
            )
        : undefined
    )
  );

  // find active sub menu
  function getActiveMenu(data: any[]) {
    const strArr = stringToArray(location.pathname, "/");
    return data?.find((el) => el?.key === strArr[1])?.children ? true : false;
  }

  return (
    <Sider
      trigger={null}
      theme="dark"
      collapsible
      collapsed={collapsed}
      className="!h-screen !sticky top-0"
      width={322}
    >
      <div
        className={`h-[108px] flex items-center sticky top-0 z-50 dark:bg-header bg-white ${
          collapsed
            ? "pl-0 justify-center text-center"
            : "pl-5 !justify-between w-full"
        }`}
      >
        <Link
          className="flex items-center justify-between gap-1 w-full"
          to="/admin/dashboard"
        >
          {!collapsed && (
            <Image
              // height={collapsed ? 35 : 57}
              src={Sheba_Logo}
              alt={APP_NAME}
              style={{ objectFit: "contain" }}
              width="auto"
            />
          )}
          {collapsed ? (
            <div className="flex items-center justify-center w-full h-full">
              <Image
                // height={collapsed ? 35 : 57}
                src={BSRM_Logo_2}
                alt={APP_NAME}
                style={{ objectFit: "contain" }}
                width="auto"
              />
            </div>
          ) : (
            <Image
              // height={collapsed ? 35 : 57}
              src={BSRM_Logo}
              alt={APP_NAME}
              style={{ objectFit: "contain" }}
              width="auto"
            />
          )}
        </Link>
      </div>

      <div className="!overflow-auto h-[calc(100vh-108px)] !sticky top-0 dark:bg-header bg-white custom-scrollbar">
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[
            activePathString(location.pathname, "/", getActiveMenu(MenuItems)),
          ]}
          openKeys={openMenuKeys}
          onOpenChange={handleOpenMenu}
          items={MenuItems}
          className={`dark:bg-header bg-white !px-4 !select-none ${
            collapsed ? "px-3" : ""
          }`}
          rootClassName="custom-sidebar"
        />
      </div>

      {/* <div className={`px-[24px] pt-0 pb-8 absolute bottom-0 w-full`}>
        {!collapsed ? (
          <>
            <p className="dark:text-header text-others-body text-[14px] mb-1.2">
              Powered by
            </p>
            <img width={154} src={upscaleLogo} alt={APP_NAME} />
          </>
        ) : (
          <img width={49} src={upscaleLogo} alt={APP_NAME} />
        )}
      </div> */}
    </Sider>
  );
}
